const audioStatus = {
	start: 'at-start',
	pause: 'is-paused',
	play: 'is-playing'
}

class SoundSnippet {
	constructor({el, durationEl}) {
		this.el = el;
		this.durationEl = durationEl;
		this.isPlaying = false;
		this.bgColor = '#00D9AD';
		this.posX = 0;
		this.status = audioStatus.start;


		this.createAudio(this.el.dataset.sound);
	}

	createAudio(audioSrc) {
		this.audioFile = new Audio();
		this.audioFile.preload = 'metadata';
		this.audioFile.src = audioSrc;

		this.audioFile.addEventListener("loadedmetadata", () => this.audioFileExists()); 		
	}

	audioFileExists() {
		this.audioFile.addEventListener('timeupdate', () => this.timeUpdate());
		this.audioFile.addEventListener('ended', () => this.reachedEnd());
		this.el.addEventListener('click', () => this.onPlayClick());

		if(this.durationEl){
			// this.durationEl.innerHTML = `0:${Math.round(this.audioFile.duration)}`;
		}

		this.updateClassNames();
	}

	updateClassNames() {
		this.el.className = `knd-sound-active ${this.status}`;
	}

	timeUpdate() {
		// update the handle position
		let totalTime = this.audioFile.duration;
		let ratio = this.audioFile.currentTime / this.audioFile.duration;
		let percentage = Number(ratio * 100).toFixed(2); 

		this.posX = percentage;
		this.updateStyle();
	}

	reachedEnd() {
		this.status = audioStatus.start;
		this.isPlaying = false;
		this.updateStyle();
		this.updateClassNames();
	}

	onPlayClick() {
		this.isPlaying = !this.isPlaying;

		if (this.isPlaying) {
			this.status = audioStatus.play;
			this.audioFile.play();
		} else {
			this.status = audioStatus.pause;
			this.audioFile.pause();
		}
		
		this.updateClassNames();
	}

	updateStyle() {
		const bg =  this.posX === 0 ? '' : `linear-gradient(to right, ${this.bgColor} ${this.posX}%, #E1E1E1 ${this.posX}%)`;
		this.el.style.background = bg;
	}
}

export default SoundSnippet;